/**
 * ViewModeContext — Allows admin/broker/owner users to switch between admin and agent views.
 * Stored in sessionStorage so it resets each session (they choose each login).
 */
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ViewModeContext = createContext(null);

export function ViewModeProvider({ children }) {
  const [viewMode, setViewModeState] = useState(() => {
    try { return sessionStorage.getItem('reve_viewMode') || 'admin'; } catch { return 'admin'; }
  });

  const setViewMode = useCallback((mode) => {
    setViewModeState(mode);
    try { sessionStorage.setItem('reve_viewMode', mode); } catch { /* ok */ }
  }, []);

  const value = useMemo(() => ({
    viewMode,
    setViewMode,
    isAdminView: viewMode === 'admin',
    isAgentView: viewMode === 'agent',
  }), [viewMode, setViewMode]);

  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  const ctx = useContext(ViewModeContext);
  if (!ctx) return { viewMode: 'admin', setViewMode: () => {}, isAdminView: true, isAgentView: false };
  return ctx;
}
